import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import Author from '~/client/components/author/author';
import BackgroundImage from '~/client/components/background-image/background-image';
import BecomeMemberModule from '~/client/components/become-member-module/become-member-module';
import Breadcrumbs from '~/client/components/breadcrumbs/breadcrumbs';
import Containment from '~/client/components/containment/containment';
import ContentContainer from '~/client/components/content-container/content-container';
import Layout from '~/client/components/layout/layout';
import RichText from '~/client/components/rich-text/rich-text';
import type { InspirationalArticlePage as Props } from './inspirational-article-page.types';

const InspirationalArticlePage: React.FunctionComponent<Props> = ({
  author,
  body,
  breadcrumbs,
  category,
  categoryLabel,
  headerImage,
  heading,
  intro,
  layout,
  memberCta,
}) => (
  <Layout {...layout}>
    <Breadcrumbs {...breadcrumbs} />
    <article className="inspirational-article-page">
      {headerImage ? (
        <div className="inspirational-article-page__header">
          <BackgroundImage
            {...headerImage}
            focusArea={BackgroundImage.focusAreas.Face}
            className="inspirational-article-page__header-image"
          />
        </div>
      ) : null}
      <section className="inspirational-article-page__main">
        <ContentContainer theme={ContentContainer.themes.medium}>
          <div className="inspirational-article-page__title">
            <Text
              elementName="h1"
              size={Text.sizes.headline2}
              theme={Text.themes.headline}
              italic
            >
              {heading}
            </Text>
          </div>
        </ContentContainer>
        <ContentContainer theme={ContentContainer.themes.narrow}>
          <Text elementName="p" size={Text.sizes.large}>
            {intro}
          </Text>
        </ContentContainer>
        <ContentContainer theme={ContentContainer.themes.narrow}>
          {author ? <Author {...author} /> : null}
          <section className="inspirational-article-page__category">
            <Text elementName="p" size={Text.sizes.small}>
              {categoryLabel}
            </Text>
            <Text
              elementName="p"
              size={Text.sizes.small}
              theme={Text.themes.emphasis}
            >
              {category}
            </Text>
          </section>
        </ContentContainer>
        {body ? (
          <ContentContainer theme={ContentContainer.themes.narrow}>
            <RichText {...body} theme={RichText.themes.boldMarkerList} />
          </ContentContainer>
        ) : null}
        {memberCta ? (
          <ContentContainer theme={ContentContainer.themes.narrow}>
            <Containment>
              <BecomeMemberModule {...memberCta} />
            </Containment>
          </ContentContainer>
        ) : null}
      </section>
    </article>
  </Layout>
);

export default InspirationalArticlePage;
